module.exports = __webpack_public_path__ + "static/red-heart-a6d445f315464901b8ff8cf90c35056e.png";